// src/encounter/wrap-up-note-lines-model.ts
// PROD-2947 · the words and pure rules behind wrap-up-note-lines.tsx. Kept apart from the components (react-refresh).
import { FOLLOWUP_UNITS, type FollowUpUnit } from '@/types/wrap-up-api';

export const INSTRUCTIONS_LABEL = 'Patient instructions';
export const FOLLOW_UP_LABEL = 'Follow-up';
export const NONE_RECORDED = 'None recorded';

export const UNIT_OPTIONS = FOLLOWUP_UNITS.map((u) => ({ value: u, label: u }));

/** "2 weeks" / "1 week" / "None" — the read-only follow-up. */
export function followUpText(count: number, unit: FollowUpUnit): string {
  if (!count || count <= 0) return 'None';
  const word = unit.toLowerCase();
  return `${count} ${count === 1 ? word.replace(/s$/, '') : word}`;
}

